import React from 'react';

interface IDashedBarProps {
  x: number;
  y: number;
  width: number;
  height: number;
  value: number;
  fill: string;
}

export const DashedBar = (props: IDashedBarProps) => {
  const { x: oX, y: oY, width: oWidth, height: oHeight, fill } = props;

  const x = oX;
  const y = oHeight < 0 ? oY + oHeight : oY;
  const width = oWidth;
  const height = Math.abs(oHeight);

  return (
    <svg>
      <pattern
        id='pattern-stripe'
        width='8'
        height='8'
        patternUnits='userSpaceOnUse'
        patternTransform='rotate(45)'
      >
        <rect width='4' height='8' transform='translate(0,0)' fill='white'></rect>
      </pattern>
      <mask id='mask-stripe'>
        <rect x='0' y='0' width='100%' height='100%' fill='url(#pattern-stripe)' />
      </mask>
      <rect
        fill='none'
        fillOpacity='0%'
        x={x}
        y={y}
        width={width}
        height={height}
        stroke={fill}
        strokeWidth={'2px'}
      ></rect>
      <rect fill={fill} mask='url(#mask-stripe)' x={x} y={y} width={width} height={height}></rect>
    </svg>
  );
};
